var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatlab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 234,
    viewBox: "0 0 257 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.429 133.714L72.4287 100.286C72.4287 100.286 78.0001 91.9286 86.3573 83.5714C94.7144 75.2143 101.601 73.2531 111.429 66.8571C130.99 54.132 147.643 0 172.714 0L111.429 133.714Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7143 167.511L0 128.143L72.4286 100.286L112.972 130.734L72.4286 161.94L55.7143 167.511Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.715 0C200.572 0 245.143 150.429 256.286 189.429C256.286 189.429 217.192 152.49 195.001 156C172.81 159.51 164.525 192.482 140.818 215.926C125.358 231.214 111.429 234 111.429 234C111.429 234 110.281 188.738 83.572 172.714C69.6434 164.357 55.7148 167.143 55.7148 167.143C55.7148 167.143 89.4164 150.98 108.499 121.602C127.581 92.2239 153.215 0 172.715 0Z",
    fill: "url(#paint2_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 120.594,
    y1: 43.9084,
    x2: 143.503,
    y2: 116.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#3F5352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#442729"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0,
    y1: 133.899,
    x2: 204.889,
    y2: 133.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#3F5352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442729"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 55.7148,
    y1: 117,
    x2: 256.286,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#53140F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#84360F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#B85B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#DF7610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F68710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#FF8D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#FD8A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F58010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#E86F10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#D65811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#C03A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B72F11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256.286,
    height: 234,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatlab);
export default __webpack_public_path__ + "static/media/matlab.98ad4951a611278e7e5b21109b9798b3.svg";
export { ForwardRef as ReactComponent };